module.exports = {"320371001":"金山桥街道","320371002":"东环街道","320371003":"大黄山街道","320371004":"大庙街道","320371005":"金龙湖街道","320371101":"徐庄镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320371.json
// module id = 856
// module chunks = 0